import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AllotmentsComponent } from './allotments/allotments.component';
import { CohortsComponent } from './cohorts/cohorts.component';
import { OrganizationsComponent } from './organizations/organizations.component';
import { UsersComponent } from './users/users.component';
import { LibModule } from '@ui-components/lib.module';
import { AccountComponent } from './account.component';
import { ProductsComponent } from './products/products.component';
import { AllocateComponent } from './allocate/allocate.component';
import { ReactiveFormsModule } from '@angular/forms';
import { UserModalComponent } from './user-modal/user-modal.component';
import { CohortModalComponent } from './cohort-modal/cohort-modal.component';
import { AddUserModalComponent } from './add-cohort-user-modal/add-cohort-user-modal.component';
import { OrganizationModalComponent } from './organization-modal/organization-modal.component';
@NgModule({
  declarations: [
    AccountComponent,
    AddUserModalComponent,
    AllotmentsComponent,
    AllocateComponent,
    CohortsComponent,
    CohortModalComponent,
    OrganizationsComponent,
    UsersComponent,
    ProductsComponent,
    UserModalComponent,
    OrganizationModalComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    LibModule
  ],
  exports: [
    AccountComponent
  ],
})
export class AccountModule { }
